import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import { recordTrack } from '@saucelabs/sl-util-segmentio';
import accepts from 'attr-accept';

import Styles from './UploadAppButton.styles';

const UploadAppButton = ({ onUploadClick, onSelectFile }) => {
  const inputFile = useRef(null);

  const handleFileUpload = (event) => {
    const { target: { files, accept } } = event;

    if (accepts(files[0], accept)) {
      onSelectFile(event.target.files[0]);
      onUploadClick(false);
      recordTrack('App file selected through file browser');
    }

    inputFile.current.value = '';
  };

  return (
    <React.Fragment>
      <input
        ref={inputFile}
        accept=".apk,.ipa"
        className={Styles.inputFile}
        onChange={handleFileUpload}
        type="file"
      />
      <Button
        category="action"
        onClick={() => inputFile.current.click()}
      >
        Browse File
      </Button>
    </React.Fragment>
  );
};

UploadAppButton.propTypes = {
  onSelectFile: PropTypes.func.isRequired,
  onUploadClick: PropTypes.func.isRequired,
};

export default UploadAppButton;
